<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form :model="state.model" ref="formDom">
        <div style="font-weight: 600; font-size: 13px; margin-bottom: 10px">
          基本信息
        </div>
        <div
          style="
            display: grid;
            grid-template-columns: 2.2fr 3fr 1.5fr 1.5fr;
            column-gap: 2%;
          "
        >
          <el-form-item
            label="名称"
            prop="name"
            :rules="[
              { required: true, message: '请填写名称', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.name"></el-input>
          </el-form-item>
          <el-form-item
            label="扣缴义务人"
            prop="withholding_agent_id"
            :rules="[
              {
                required: true,
                message: '请选择扣缴义务人',
                trigger: 'blur',
              },
            ]"
          >
            <el-select
              v-model="state.model.withholding_agent_id"
              placeholder="--选择扣缴义务人--"
              size="large"
            >
              <el-option
                v-for="item in state.withholdingagentData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
              <template #footer>
                <el-button size="small" @click="onLoadWithholdingAgent()">
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="更正年份"
            prop="year"
            :rules="[
              { required: true, message: '请选择更正年份', trigger: 'blur' },
            ]"
          >
            <el-date-picker
              v-model="state.model.year"
              type="year"
              placeholder="更正年份"
              format="YYYY年"
              value-format="YYYY"
              style="width: 100%"
            />
          </el-form-item>

          <el-form-item
            label="申报类型"
            prop="declare_type"
            :rules="[
              {
                required: true,
                message: '请选择申报类型',
                trigger: 'blur',
              },
            ]"
          >
            <el-select
              v-model="state.model.declare_type"
              placeholder="申报类型"
            >
              <el-option
                v-for="item in $constant.taxdeclare_declare_type"
                :key="item.Key"
                :label="item.Text"
                :value="item.Key"
              />
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="更正说明">
          <el-input
            type="textarea"
            v-model="state.model.remark"
            :autosize="{ minRows: 2 }"
          />
        </el-form-item>
      </el-form>
      <div
        style="
          font-size: 13px;
          margin: 10px 0;
          display: flex;
          align-items: center;
        "
      >
        <li style="font-weight: 600; display: flex; align-items: center">
          人员信息
        </li>
        <li
          style="
            display: flex;
            align-items: center;
            column-gap: 5px;
            flex: 1;
            justify-content: center;
          "
        >
          <text style="color: #080"
            >已添加<strong style="font-size: 140%">{{
              state.employee_arr?.length || 0
            }}</strong
            >人</text
          >
          <el-divider direction="vertical" />
          <text style="color: #1e90ff"
            >已选择<strong style="font-size: 140%">{{
              onGetSelectCount()
            }}</strong
            >人</text
          >
        </li>
        <el-button
          type="primary"
          link
          icon="Plus"
          size="small"
          @click="onShowEmployee"
        >
          添加人员
        </el-button>
        <el-button
          type="warning"
          link
          icon="Setting"
          size="small"
          @click="onSetSkssqs"
        >
          批量设置税款所属期
        </el-button>
        <el-button
          type="danger"
          link
          icon="Delete"
          size="small"
          @click="onDeletes"
        >
          批量删除
        </el-button>
      </div>
      <div
        style="flex: 1; display: flex; flex-direction: column; overflow: hidden"
      >
        <el-table
          :data="state.employee_arr"
          v-loading="!Array.isArray(state.employee_arr)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          ref="tableDom"
          @row-click="onRowClick"
          :key="state.key"
        >
          <el-table-column type="selection" width="55" fixed />
          <el-table-column
            fixed
            label="序号"
            width="70"
            type="index"
            align="center"
          />
          <el-table-column
            prop="name"
            label="姓名"
            :formatter="$tab_TextFormat"
          />
          <el-table-column prop="phone" label="手机号">
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                title="手机号"
                @click="$onCopy(row.phone)"
              >
                {{ row.phone }}
              </text>
            </template>
          </el-table-column>
          <el-table-column prop="idcard" label="证件号">
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                title="证件号"
                @click="$onCopy(row.idcard)"
              >
                {{ row.idcard }}
              </text>
            </template>
          </el-table-column>
          <el-table-column
            label="状态"
            :formatter="
              (row) =>
                $statusFormat({
                  Text: row.status == 0 ? '停用' : '正常',
                  Color: row.status == 0 ? '#f00' : '#1e90ff',
                })
            "
          />
          <el-table-column
            prop="sex"
            label="性别"
            align="center"
            :formatter="$tab_TextFormat"
          />
          <el-table-column prop="skssq" label="税款所属期" align="center">
            <template #default="{ row }">
              <div v-if="row.skssq">
                {{ $dayjs(row.skssq).format("YYYY年M月") }}
                <el-button
                  type="warning"
                  link
                  size="small"
                  @click.stop="
                    state.skssq = row.skssq;
                    state.select_item = row;
                    state.showSetSkssq = true;
                  "
                  >变更</el-button
                >
              </div>
              <el-button
                v-else
                type="primary"
                link
                size="small"
                @click.stop="
                  delete state.skssq;
                  state.select_item = row;
                  state.showSetSkssq = true;
                "
                >设置</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showEmployee"
        title="选择人员"
        @close="state.showEmployee = false"
      >
        <c_TaxDeclareCorrectSelectEmployee
          @confirm="onSelectEmployeeConfirm"
          :withholding_agent_id="state.model?.withholding_agent_id"
          :select_ids="state.employee_arr.map((m) => m.id)"
        ></c_TaxDeclareCorrectSelectEmployee>
      </c_popup>
    </transition>
  </div>
  <el-dialog
    v-model="state.showSetSkssq"
    :title="'设置' + state.select_item?.name + '的税款所属期'"
    width="400px"
    align-center
  >
    <el-date-picker
      v-model="state.skssq"
      type="month"
      placeholder="税款所属期"
      format="YYYY年M月"
      value-format="YYYYMM"
      style="width: 100%"
    />
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 20px;
      "
    >
      <el-button @click="state.showSetSkssq = false">取消</el-button>
      <el-button
        type="primary"
        @click="
          state.select_item.skssq = state.skssq;
          state.showSetSkssq = false;
        "
      >
        提交
      </el-button>
    </div>
  </el-dialog>
  <el-dialog
    v-model="state.showSetSkssqs"
    title="批量设置税款所属期"
    width="500px"
    align-center
  >
    <el-date-picker
      v-model="state.skssqs"
      type="month"
      placeholder="税款所属期"
      format="YYYY年M月"
      value-format="YYYYMM"
      style="width: 100%"
    />
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 20px;
      "
    >
      <el-button @click="state.showSetSkssqs = false">取消</el-button>
      <el-button type="primary" @click="onConfirmSkssqs">暂存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { taxdeclarecorrect_add } from "@/http/taxdeclarecorrect";
import { data_withholdingagent_select } from "@/http/data";
import { post_response } from "@/utils/qFormat";
import { ElMessage } from "element-plus";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const tableDom = ref(null);
    const formDom = ref(null);
    const state = reactive({
      model: {},
      employee_arr: [],
    });
    onMounted(() => {
      onLoadWithholdingAgent();
    });

    //获取扣缴义务人
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_select().then((res) => {
        if (res.status == 200) state.withholdingagentData = res.data.data?.list;
      });
    };

    const onSelectEmployeeConfirm = (res) => {
      const { ids, arr } = res;

      if (!state.employee_arr) state.employee_arr = [];
      state.employee_arr = state.employee_arr.filter((w) => ids.includes(w.id));

      const employee_arr_ids = state.employee_arr.map((m) => m.id);

      const add_arr = arr.filter((w) => !employee_arr_ids.includes(w.id));

      add_arr.forEach((e) => {
        state.employee_arr.push(e);
      });

      state.showEmployee = false;
    };

    const onShowEmployee = () => {
      if (!state.model.withholding_agent_id) {
        ElMessage({
          type: "warning",
          message: "请先选择扣缴义务人！",
          grouping: true,
        });
        return false;
      }

      state.showEmployee = true;
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    const onSetSkssqs = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择人员",
          grouping: true,
        });
        return false;
      }

      state.showSetSkssqs = true;
    };

    const onConfirmSkssqs = () => {
      if (!state.skssqs) {
        ElMessage({
          type: "warning",
          message: "请选择税款所属期",
          grouping: true,
        });
        return false;
      }

      const rows = tableDom.value.getSelectionRows();
      rows.forEach((e) => {
        e.skssq = state.skssqs;
      });

      ElMessage({
        type: "success",
        message: "设置成功！",
        grouping: true,
      });
      state.showSetSkssqs = false;
    };

    const onGetSelectCount = () => {
      return tableDom?.value?.getSelectionRows()?.length || 0;
    };

    const onDeletes = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择人员",
          grouping: true,
        });
        return false;
      }

      let ids = rows.map((m) => m.id);
      state.employee_arr = state.employee_arr.filter(
        (w) => !ids.includes(w.id)
      );
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (state.employee_arr?.length <= 0) {
            ElMessage({
              type: "warning",
              message: "请选择人员",
              grouping: true,
            });
            return false;
          }

          const unSetCount = state.employee_arr.filter((w) => !w.skssq).length;
          if (unSetCount > 0) {
            ElMessage({
              type: "warning",
              message: `尚有${unSetCount}人未设置税款所属期，禁止提交！`,
              grouping: true,
            });
            return false;
          }

          state.model.employee_data = JSON.stringify(
            state.employee_arr.map((m) => {
              return {
                employee_id: m.id,
                skssq: m.skssq,
              };
            })
          );

          taxdeclarecorrect_add(state.model).then((res) => {
            post_response(res, emit);
          });
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onLoadWithholdingAgent,
      onSubmit,
      onSelectEmployeeConfirm,
      tableDom,
      onSetSkssqs,
      onRowClick,
      onShowEmployee,
      onConfirmSkssqs,
      onGetSelectCount,
      onDeletes,
    };
  },
};
</script>
<style scoped lang="less"></style>
